<template>
    <b-overlay
        :show="status.isWaiting"
        variant="light"
        spinner-variant="primary"
    >
        <div class="bg-white rounded">
            <b-row class="justify-content-lg-center">
                <b-col>
                    <b-table id="customersTable" class="mb-1" responsive outlined borderless striped hover show-empty :empty-text="$t('app_table_empty_text')" :items="customers.customers" :fields="fields" :per-page="perPage" :current-page="currentPage">
                        <template v-slot:head(name)>
                            {{ $t('customer_label_name') }}
                        </template>
                        <template v-slot:head(street_address)>
                            {{ $t('customer_label_street_address') }}
                        </template>
                        <template v-slot:head(zip)>
                            {{ $t('customer_label_zip_code') }}
                        </template>
                        <template v-slot:head(city)>
                            {{ $t('customer_label_city') }}
                        </template>
                        <template v-slot:head(isActive)>
                            {{ $t('customer_label_is_active') }}
                        </template>
                        <template v-slot:head(actions)>
                            {{ $t('customer_label_actions') }}
                        </template>
                        <template v-slot:cell(street_address)="{ item }">
                            {{ item.billingAddress.street ? item.billingAddress.street : "-" }}
                        </template>
                        <template v-slot:cell(zip)="{ item }">
                            {{ item.billingAddress.zip ? item.billingAddress.zip : "-" }}
                        </template>
                        <template v-slot:cell(city)="{ item }">
                            {{ item.billingAddress.city ? item.billingAddress.city : "-" }}
                        </template>
                        <template v-slot:cell(isActive)="{ item }">
                            {{ item.isActive ? $t('app_yes') : $t('app_no') }}
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <a :href="`/customer/${item.apiId}`" type="button" class="btn btn-sm btn-info">{{ $t('customer_button_view') }}</a>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <b-row class="justify-content-lg-center pl-2 pr-2">
                <b-col>
                    <label>
                        <small><b>{{ $t('app_table_label_per_page') }}</b></small>
                        <b-form-select size="sm" v-model="perPage" :options="perPageOptions" />
                    </label>
                </b-col>
                <b-col class="d-flex">
                    <b-pagination class="my-auto ml-auto" align="right" v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="customersTable" /> 
                </b-col>
            </b-row>
        </div>
		<b-row class="justify-content-lg-center" v-if="checkRole(user, 'ROLE_ADMIN')">
			<b-col>
                <hr />
                <button type="button" class="btn btn-success" @click="customersSync" :disabled="syncDisabled">{{ $t('customer_button_sync') }}</button>
			</b-col>
		</b-row>

		<b-modal 
            v-if="checkRole(user, 'ROLE_ADMIN')"
            ref="syncModal" 
            size="md" 
            :title="$t('customer_sync_modal_title')" 
            ok-only
            :ok-title="$t('customer_sync_modal_button_ok')"
            @hidden="closeSyncModal"
        >
            <b-list-group v-if="customers && customers.sync">
                <b-list-group-item>{{ $t('customer_sync_created') }}: {{ customers.sync.created }}</b-list-group-item>
                <b-list-group-item>{{ $t('customer_sync_updated') }}: {{ customers.sync.updated }}</b-list-group-item>
                <b-list-group-item>{{ $t('customer_sync_deactivated') }}: {{ customers.sync.deactivated }}</b-list-group-item>
            </b-list-group>
		</b-modal>
    </b-overlay>
</template>

<script>
export default {
    name: 'CustomerIndex',
    props: [
        'user',
        'checkRole',
        'customers',
        'status',
        'syncCustomersCall',
        'syncDisabled',
        'showSyncModal',
        'closeSyncModal'
    ],
    data() {
        return {
            perPageOptions: [ 5, 10, 25, 50, 100 ],
            perPage: 25,
            currentPage: 1,
            fields: [
                { key: 'name', sortable: true },
                //{ key: 'street_address', sortable: true },
                //{ key: 'zip', sortable: true },
                //{ key: 'city', sortable: true },
                { key: 'isActive', sortable: true },
                { key: 'actions', sortable: false },
            ],
        }
    },
    computed: {
        rows() {
            return this.customers && this.customers.customers ? this.customers.customers.length : 0;
        }
    },
    methods: {
        customersSync() {
            this.syncCustomersCall();
        },
    },
	watch: {
        showSyncModal() {
            if (this.showSyncModal) {
                this.$refs['syncModal'].show();
            }
        },
	},
}
</script>
